import cn from 'classnames'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { cartCount, compareItem } from '../../redux/selectors'
import { changeCartItemCount, removeCartItem, toggleCompare } from '../../redux/reducers'
import Rating from '../rating/rating'
import { Price } from '../price/price'
import { ReactComponent as CompareIcon } from '../../assets/svg/bars.svg'


const CardProduct = ({ product, tiles, withRating = true }) => {
   const { id, url, productUrl, title, img, alt, price, p, r, reviewsCount, newItem, promo } = product
   const handleClick = () => dispatch(count === 0 ? changeCartItemCount({ id, count: 1 }) : removeCartItem(id))
   const isCompareItem = useSelector(compareItem(productUrl))
   const [hover, setHover] = useState(false)
   const count = useSelector(cartCount(id))
   const dispatch = useDispatch()

   return (
      <div className={cn('card-product', { row: !tiles }, { hover: hover })}>
         <div className='card-product__header'>
            {newItem && <span className='card-product__bage card-product__new'>НОВИНКА</span>}
            {promo && <span className='card-product__bage card-product__promo'>АКЦИЯ</span>}

            <button
               className={cn('card-product__btn-compare', { active: isCompareItem })}
               onClick={() => dispatch(toggleCompare(productUrl))}
               aria-label={`сравнить товар ${title}`}
            >
               <CompareIcon />
            </button>
         </div>

         <Link
            className='card-product__link'
            to={`/products/${url}/${productUrl}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
         >
            <img src={img} alt={alt} width='600' height='600' />
         </Link>

         {withRating && (
            <Rating r={r} className='card-product__rating'>
               <span>({reviewsCount})</span>
            </Rating>
         )}

         <h2 className='card-product__title'>{title}</h2>

         <div className='card-product__row'>
            <Price price={price} p={p} promo={promo} className='card-product__price' />
            <button className={cn('card-product__btn-cart', { active: count !== 0 })} onClick={handleClick}>
               В КОРЗИНУ
               <svg viewBox='0 0 16 16' fill='none'>
                  <path strokeWidth='1' strokeLinecap='round' strokeLinejoin='round' d='M4 8.27273L6.5 11L12 5' />
               </svg>
            </button>
         </div>
      </div>
   )
}

export default CardProduct
